import Icon from "components/Icon/Icon";
import styled from "styled-components";

const PAYMENT_METHOD_GAP = "10px";

export const PaymentOptions = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${PAYMENT_METHOD_GAP};
`;

export const PaymentMethodButton = styled.button`
  display: flex;
  align-items: center;
  gap: 14px;
  width: fit-content;
  user-select: none;
`;

export const PaymentMethodRadio = styled(Icon)<{ $selected: boolean }>`
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  background-color: ${({ $selected, theme }) =>
    $selected ? theme.primaryAccent : theme.lightgrey};
`;

export const PaymentMethodTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
  line-height: 1.35;
  color: ${({ theme }) => theme.black};
`;

export const PaymentMethodLogo = styled.img`
  display: block;
  width: auto;
  height: 33px;
`;
